export enum ButtonTypes {
    PRIMARY = 'primary',
    SECONDARY = 'secondary',
    SECONDARY_WHITE = 'secondary-white',
    ACCENT = 'accent',
    NO_OUTLINE = "no_outline",
    DARK = "dark",
    ERROR = "error"
}